/* global window document */

import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, browserHistory as history, Switch } from 'react-router-dom';
import ConserveParameters from '@3plearning/routing-conserve-parameters';
import { isMobile } from 'react-device-detect';
import ProductCss from '@3plearning/3p-css-templates';
import queryString from 'querystring';
import { I18nProvider } from '@lingui/react';
import '../../styles/core.scss';
import BasicApp from './basic-app';
import PageHeader from '../../components/page-header/page-header';
import PageFooter from '../../components/page-footer/page-footer';
import WholeClass from '../whole-class/whole-class';
import Students from '../students/students';
import ConfirmationModal from '../confirmation-modal/confirmation-modal';
import BusyIndicator from '../../components/busy-indicator/busy-indicator';
import ErrorHandling from '../../helpers/error-handling';
import { getLocale } from '../../helpers/utils';
import enCatalog from '../../locale/en_AU/messages';
import enMXCatalog from '../../locale/es_MX/messages';
import Toast from '../../components/toast/index';
import i18nSetup from '../../helpers/locale';

ConserveParameters(['username', 'password', 'userToken', 'productId', 'lang']);

const catalogs = {
    en: enCatalog,
    es: enMXCatalog
};

const i18n = i18nSetup(catalogs);

export default class EntryApp extends BasicApp {
    render(store) {
        // TODO: 4. DEFINE THE TOP-LEVEL ROUTES FOR YOUR APPLICATION'S COMPONENTS HERE

        // When executing on demo, QA, or production, the host app will inject a property
        // called pppAppConfig into the global window variable.  This will provide the
        // base name of the app.  Most of the time that will be an empty string, but in
        // case it is not, we will extract it and pass it to the router, below.
        // this.getConfig();

        const queryParams = window.location.search;
        const query = queryParams.replace('?', '');
        // eslint-disable-next-line no-underscore-dangle
        const appConfig = window._env_;
        const params = queryString.parse(query);
        const backUrl = params.backUrl;
        const productId = params.productId || 1;
        const adminMode = window.location.pathname.indexOf('admin-students') >= 0;
        const locale = getLocale();
        const BASE_NAME = appConfig ? appConfig.BaseName : '';

        store.dispatch({
            type: 'UPDATE_QUERY_PARAMS',
            payload: params
        });

        // eslint-disable-next-line no-underscore-dangle
        const cssConfig = window._env_ && window._env_.ProductCss;
        if (cssConfig) {
            ProductCss.loadCssPath(adminMode ? cssConfig.admin : cssConfig[productId]);
        }


        // Add an interceptor to handle errors when accessing resources
        ErrorHandling.addResourceResponseErrorInterceptor(store.dispatch);
        // Add a device-detection for enabling ipad scrolling in portal
        if (isMobile) {
            document.querySelector('.application').classList.add('ipad-position-fixed-wrapper');
        }

        // NOTE: We have used a "render" attribute, rather than "component" to specify what
        //       should be rendered.  This allows us to pass options to the component. You
        //       can obviously simplify things if your components don't need any.
        return (
            <Provider store={store}>
                <I18nProvider
                    language={locale}
                    defaultRender={'span'}
                    catalogs={{
                        en: enCatalog,
                        es: enMXCatalog
                    }}
                >
                    <div>
                        <PageHeader class="page-header" />
                        <div className="main-content">
                            <Router history={history} basename={BASE_NAME} class="main-content">
                                <Switch>
                                    <Route
                                        path="/whole-class"
                                        render={props => (
                                            <WholeClass productId={productId} options={this.options} {...props} />)
                                        } />
                                    <Route
                                        path="/students"
                                        render={props =>
                                            (<Students
                                                productId={productId}
                                                options={this.options}
                                                i18n={i18n}
                                                {...props} />)}
                                    />
                                    <Route
                                        path="/admin-students"
                                        render={props =>
                                            (<Students
                                                productId={productId}
                                                options={this.options}
                                                {...props}
                                                headerInfo={{ title: 'School Roll', subTitle: 'STUDENT MANAGEMENT' }}
                                                backUrl={backUrl}
                                                i18n={i18n}
                                            />)}
                                    />
                                </Switch>
                            </Router>
                        </div>
                        <PageFooter />
                        <ConfirmationModal />
                        <BusyIndicator />
                        <Toast />
                    </div>
                </I18nProvider>
            </Provider>
        );
    }
}

window.EntryApp = EntryApp;



// WEBPACK FOOTER //
// ./containers/app/entry-app.js